export default class FeatureFlagIds {
    static readonly REQUIRE_AUTHENTICATION = "require_authentication";
    static readonly ENABLE_SALE_ENQUIRIES = "enable_sale_enquiries";
    static readonly VALUATION_BLOCKLIST = "valuation_blocklist";
}
